import fetch from '../utils/request'

// 获取菜单列表
export function GetMenuList(params) {
    return fetch('menu/list', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}